import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import {
  routes,
  theme as cnbTheme,
  useInitialPath,
  GaWrapper,
  InitialPathContext,
  SpinnerWrapper,
} from "./common";
import {
  useAuth,
  AuthContext,
  LoginPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from "./auth";
import MagicLinkLoginPage from "./auth/MagicLinkLoginPage";
import { DashboardPage } from "./button";
import MagicSignupPage from "./auth/MagicSignupPage";
import Callback from "./auth/oauth2/Callback";
import { oauth2Enabled } from "./auth/oauth2/oauth2Config";

const App: React.FC = () => {
  const initialPathContextValue = useInitialPath();
  const authContextValue = useAuth();
  return (
    <ThemeProvider theme={cnbTheme}>
      <CssBaseline />
      <SpinnerWrapper>
        <InitialPathContext.Provider value={initialPathContextValue}>
          <AuthContext.Provider value={authContextValue}>
            <BrowserRouter>
              <GaWrapper>
                <Switch>
                  {authContextValue.loggedIn && [
                    <Redirect
                      key={routes.LOGIN.path}
                      from={routes.LOGIN.path}
                      to={routes.DASHBOARD.path}
                    />,
                    <Redirect
                      key={routes.REGISTER.path}
                      from={routes.REGISTER.path}
                      to={routes.DASHBOARD.path}
                    />,
                    <Redirect
                      key={routes.USERNAME_PASSWORD_LOGIN.path}
                      from={routes.USERNAME_PASSWORD_LOGIN.path}
                      to={routes.DASHBOARD.path}
                    />,
                    <Redirect
                      key={routes.MAGIC_TOKEN_LOGIN.path}
                      from={routes.MAGIC_TOKEN_LOGIN.path}
                      to={routes.DASHBOARD.path}
                    />,
                  ]}
                  {!authContextValue.loggedIn && (
                    <Redirect
                      from={routes.DASHBOARD.path}
                      to={routes.MAGIC_TOKEN_LOGIN.path}
                    />
                  )}
                  {oauth2Enabled && (
                    <Route path={routes.CALLBACK.path}>
                      <Callback />
                    </Route>
                  )}
                  <Route path={routes.DASHBOARD.path}>
                    <DashboardPage />
                  </Route>
                  <Route path={routes.USERNAME_PASSWORD_LOGIN.path}>
                    <LoginPage />
                  </Route>
                  <Route path={routes.MAGIC_TOKEN_LOGIN.path}>
                    <MagicLinkLoginPage />
                  </Route>
                  <Route path={routes.REGISTER.path}>
                    <MagicSignupPage />
                  </Route>
                  <Route path={routes.FORGOT_PASSWORD.path}>
                    <ForgotPasswordPage />
                  </Route>
                  <Route path={routes.RESET_PASSWORD.path}>
                    <ResetPasswordPage />
                  </Route>
                  <Redirect to={routes.DASHBOARD.path} />
                </Switch>
              </GaWrapper>
            </BrowserRouter>
          </AuthContext.Provider>
        </InitialPathContext.Provider>
      </SpinnerWrapper>
    </ThemeProvider>
  );
};

export default App;
